import React, { useEffect } from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Header } from '../../components/header/header';
import {
  StyledHeaderContainer,
  StyledTitleHeader
} from '../../components/layout/main/mainStyles';
import { ButtonIconStyled } from '../devices/devicesStyles';
import Strings from '../../i18n';
import { useEventProcessorSyncMutation } from '../../services/webJobs/webJobsServices';

export const WebJobs = () => {
  const navigate = useNavigate();

  const [eventProcessorSync, { isSuccess }] = useEventProcessorSyncMutation();

  useEffect(() => {
    if (isSuccess) {
      toast.success(Strings.commands.commandSentSuccessfully);
    }
  }, [isSuccess]);

  return (
    <>
      <Header>
        <StyledHeaderContainer>
          <div className="row justify-content-between">
            <div className="col-4 text-left">
              <ButtonIconStyled size="small" onClick={() => navigate(-1)}>
                <ArrowBackIosIcon />
              </ButtonIconStyled>
            </div>
            <div className="col-4 text-center">
              <StyledTitleHeader>
                {Strings.serverAccess.menu.webJobs}
              </StyledTitleHeader>
            </div>
            <div className="col-4" />
          </div>
        </StyledHeaderContainer>
      </Header>
      <div className="d-flex justify-content-flex-start align-items-center">
        <div className="card shadow-sm" style={{ width: '300px' }}>
          <div
            className="card-header text-white text-center"
            style={{ backgroundColor: '#172047' }}
          >
            {Strings.serverAccess.webJobs.table}
          </div>
          <div className="card-body text-center">
            <button
              type="button"
              className="btn btn-light mx-2"
              onClick={() => eventProcessorSync(null)}
            >
              {Strings.serverAccess.webJobs.restart}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
